
export type ChannelType = {
    id: number
    name: string
    description: string
    channelTypeId: string
    profileImageUrl: string
    coverImageUrl: string
    link: string
    about?: string
    category?: string
    channelId: string
    general_info: string | null
    is_published: boolean | null
    is_unclaimed: boolean | null
    can_checkin: boolean | null
    can_post: boolean | null
    followers_count: number | null
    fan_count: number | null
    is_webhooks_subscribed: boolean | null
    administrator: boolean | null
    unread: number | null
    icon: string | null
    groupid: string | null
    member_count: number | null
    privacy: string | null
    purpose: string | null
    cover_Id: string | null
    source: string | null
    is_silhouette: boolean | null
    url: string | null
    channelAccessId: number | null
    channelGuid: string | null
    mediumName: string
    channelTypeName: string
    selectedOnUi : boolean
}

type Address = {
    name: string
    region: string
    city: string
    state: string
    street: string
    zipcode: string
    country: string
    latitude: number
    longitude: number
}


//Default Object State
export const channelDefault: ChannelType[] = [{
    id: 0,
    name: '',
    description: '',
    channelTypeId: '',
    profileImageUrl: '',
    coverImageUrl: '',
    link: '',
    channelId: '',
    general_info: null,
    is_published: null,
    is_unclaimed: null,
    can_checkin: null,
    can_post: null,
    followers_count: null,
    fan_count: null,
    is_webhooks_subscribed: null,
    administrator: null,
    unread: null,
    icon: null,
    groupid: null,
    member_count: null,
    privacy: null,
    purpose: null,
    cover_Id: null,
    source: null,
    is_silhouette: null,
    url: null,
    channelAccessId: null,
    channelGuid: null,
    channelTypeName: "",
    mediumName: "",
    selectedOnUi : false
}];

export type InviteInfo = {
    organizationName: string,
    accepted: boolean,
    channels: InviteChannelBasicInfo[]
}

export type InviteChannelBasicInfo = {
    channelId: number,
    channelRefId: string,
    name: string,
    privilegeName: string,
    imageUrl: string
}